module.exports = __webpack_public_path__ + "images/145_640.jpg";